export default __webpack_public_path__ + "static/media/madame_detail4.44e5abd4.jpg";